import i18next from 'i18next';

i18next.addResources('es_CL', 'ErrorCheckCartModal', {
  error: '¡Oh no!',
  title: 'Ocurrió un error inesperado.',
  subtitle: 'Por favor, inténtalo más tarde.',
  retry: 'Reintentar',
  backToHome: 'Volver al menú'
});
